export const uk = {
    select: 'Вибрати',
    'zoom-in-button-text': 'Збільшити'
};
